var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',_vm._g(_vm._b({attrs:{"init":_vm.init}},'editor',_vm.editorAttrs,false),_vm.editorListeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }